import { render, staticRenderFns } from "./VehicleFlagItem.vue?vue&type=template&id=2efb8049&scoped=true"
import script from "./VehicleFlagItem.vue?vue&type=script&lang=js"
export * from "./VehicleFlagItem.vue?vue&type=script&lang=js"
import style0 from "./VehicleFlagItem.vue?vue&type=style&index=0&id=2efb8049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb8049",
  null
  
)

export default component.exports